import React, { useState, useEffect } from 'react';
import { useGame } from '../context/GameContext';
import './FinalGameResults.css';

function FinalGameResults() {
  const { currentSession, selectedTeam } = useGame();
  const [isWinner, setIsWinner] = useState(false);
  const [showContinue, setShowContinue] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    // Determine if this team is the winner
    if (currentSession?.finalGameScores && selectedTeam) {
      // Find the highest final game score
      const scores = currentSession.finalGameScores.map(score => ({
        teamId: score.teamId.toString(),
        score: score.score
      }));

      const maxScore = Math.max(...scores.map(s => s.score));
      const winnerTeamId = scores.find(s => s.score === maxScore)?.teamId;
      
      // Check if this team is the winner
      if (winnerTeamId === selectedTeam.id.toString()) {
        setIsWinner(true);
      }

      // Show continue button after a short delay
      setTimeout(() => {
        setShowContinue(true);
      }, 3000);
    }
  }, [currentSession, selectedTeam]);

  const handleContinue = () => {
    setShowLoading(true);
    // Store loading state in localStorage so it persists across re-renders
    localStorage.setItem('finalGameLoading', 'true');
  };

  if (showLoading) {
    return (
      <div className="final-game-results-container loading-screen">
        <div className="loading-content">
          <div className="loading-logo-container">
            <img 
              src="/fortuin.gif" 
              alt="Escape Room Logo" 
              className="loading-logo-gif"
            />
          </div>
          <h1>Preparing Next Game...</h1>
          <div className="spinner"></div>
          <p className="loading-message">
            Waiting for gamemaster to start a new game...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="final-game-results-container">
      {isWinner ? (
        <div className="winner-screen">
          <div className="fireworks-container">
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
            <div className="firework"></div>
          </div>
          <div className="winner-content">
            <h1 className="winner-title">🎉 Congratulations! 🎉</h1>
            <h2 className="winner-subtitle">You Won!</h2>
            <p className="winner-team">{selectedTeam?.name}</p>
            <div className="winner-score">
              <p className="score-label">Final Game Score:</p>
              <p className="score-value">
                {currentSession?.finalGameScores?.find(
                  s => s.teamId.toString() === selectedTeam?.id.toString()
                )?.score || 0}
              </p>
            </div>
            {showContinue && (
              <button onClick={handleContinue} className="btn-continue">
                Continue
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="loser-screen">
          <div className="loser-content">
            <h1 className="loser-title">You Lose</h1>
            <p className="loser-team">{selectedTeam?.name}</p>
            <div className="loser-score">
              <p className="score-label">Final Game Score:</p>
              <p className="score-value">
                {currentSession?.finalGameScores?.find(
                  s => s.teamId.toString() === selectedTeam?.id.toString()
                )?.score || 0}
              </p>
            </div>
            {showContinue && (
              <button onClick={handleContinue} className="btn-continue">
                Continue
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default FinalGameResults;

